import moment from 'moment'

export const safe = (value) =>
  value !== null && value !== undefined && value !== '' ? value : '-'

export const formatDate = (date) =>
  date ? moment(date).format('DD/MM/YYYY') : '-'
